/**
 * DB-backed Rosie role keys (seeded system roles + custom roles).
 * Session `user.type` is a role key string — not a fixed enum.
 */
export const ROSIE_SESSION_USER_TYPES = [
  'staff',
  'super-admin',
  'scla-fellow',
  'scla-app-reader',
] as const;

export type RosieSessionUserType = string;

export type KnownRosieSessionUserType =
  (typeof ROSIE_SESSION_USER_TYPES)[number];
